import type { FC } from "react";
import React, { useCallback } from "react";
import styles from "./Selection.module.scss";
import Select from "./Select";
import { useCompareContext } from "../../CompareContext";
import type { AtmosphereType } from "../../../../../../utils/types/AtmosphereType";
import { useAphLbxAtmospheres } from "../../../../../../hooks/lbx/useAphLbxAtmospheres";
import { useCarConfigLabel } from "../../../../../../utils/labelUtils";

const Selection: FC = () => {
    const allGrades = useAphLbxAtmospheres();
    const compareContext = useCompareContext();

    const setSelectedOption = useCallback(
        (newIndex: number) => (newGrade: AtmosphereType) => {
            compareContext.setGrades(compareContext.grades.map((id, index) => (newIndex === index ? newGrade.id : id)));
        },
        [compareContext],
    );

    const label = useCarConfigLabel("carConfigLbxCompareSelectToCompare");

    return (
        <div className={styles.selection}>
            <div>
                <Select
                    label={label}
                    options={allGrades.filter(({ id }) => id !== compareContext.grades[1])}
                    selectedOption={allGrades.find(({ id }) => compareContext.grades[0] === id)}
                    setSelectedOption={setSelectedOption(0)}
                />
            </div>
            <div>
                <Select
                    label={label}
                    options={allGrades.filter(({ id }) => id !== compareContext.grades[0])}
                    selectedOption={allGrades.find(({ id }) => compareContext.grades[1] === id)}
                    setSelectedOption={setSelectedOption(1)}
                />
            </div>
        </div>
    );
};
export default Selection;
